import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import "@/assets/scss/globals.scss"

// Vue.config.productionTip = false;

const app = createApp(App);

app.use(router);
app.use(vuetify);
app.mount('#app');
